import axios from 'axios'

const config = {
  baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:4004/api/' : 'https://blog.ghlogistica.com.br/api',
}

const axiosConfig = axios.create(config)

axiosConfig.defaults.headers['Content-Type'] = 'application/json'
axiosConfig.defaults.headers.Authorization = localStorage.getItem('token')


axiosConfig.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response.status === 401) {
    window.dispatchEvent(new Event('authError'))
  }
  return error;
});

export const api = axiosConfig